// @ts-nocheck
import {
  buildColumnMap,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const HUONS_FIELD_ALIASES = {
  hospitalName: ['병/의원'],
  drugCode: ['제품코드'],
  drugName: ['제품명'],
  quantity: ['수량'],
  unitPrice: ['약가'],
  prescriptionAmount: ['처방금액'],
  settlementAmount: ['정산(지급)'],
  feeRate: ['지급요율'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  'NO',
  '병/의원',
  '처방월',
  '제약회사',
  '제품코드',
  '제품명',
  '수량',
  '약가',
  '처방금액',
  '정산(지급)',
  '지급요율',
  '비고',
];

function isHuonsProfile(profile) {
  return REQUIRED_HEADERS.every((header) =>
    profile.headers.some(
      (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
    ),
  );
}

const huonsTemplate = {
  id: 'huons',
  name: '휴온스 템플릿',
  match(context) {
    return context.headerProfiles.some(isHuonsProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isHuonsProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(HUONS_FIELD_ALIASES),
    );
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const drugCode = cleanText(row[columnMap.drugCode]);
      if (!drugCode) {
        return;
      }

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany: '휴온스',
        customerName: row[columnMap.hospitalName],
        drugCode,
        drugName: row[columnMap.drugName],
        unitPriceValue: row[columnMap.unitPrice],
        quantityValue: row[columnMap.quantity],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        feeRateValue: row[columnMap.feeRate],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: row[columnMap.note],
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: '휴온스',
      templateName: this.name,
    };
  },
};

export default huonsTemplate;
